import { FeedbackAnswerPayload, FeedbackTemplateQuestion, FeedbackTemplateSnapshot } from "src/app/models/models";

export interface FeedbackTemplateListItem {
	id: string;
	name: string;
	description?: string | null;
	isStandalone?: boolean;
	recipientRoles?: string[];
	recipientRoleLabels?: string;
	dispatchedAt?: string | null;
	startsAt?: string | null;
	endsAt?: string | null;
	formId?: string | null;
	formIds?: string[];
	formName?: string;
	formTypeCode?: string;
	formTypeCodes?: string[];
	formTypeLabel?: string;
	linkedForms?: Array<{
		id: string;
		name: string;
		formTypeCode: string;
		formTypeLabel: string;
	}>;
	isActive: boolean;
	hasResponses?: boolean;
	lastUpdated?: string;
	aocCode?: string;
	questions: FeedbackTemplateQuestion[];
}

export const FEEDBACK_FORMS_ALREADY_ATTACHED = "FEEDBACK_FORMS_ALREADY_ATTACHED";
export const FEEDBACK_MAX_QUESTIONS = 30;

export interface FeedbackTemplateRequest {
	name: string;
	isStandalone?: boolean;
	recipientRoles?: string[];
	formIds?: string[];
	formTypeCodes?: string[];
	replaceExistingAttachments?: boolean;
	isActive?: boolean;
	startsAt?: string | null;
	endsAt?: string | null;
	questions: Array<{
		id?: string;
		sortOrder: number;
		prompt: string;
		required?: boolean;
		answerEnabled?: boolean;
		answerRequired?: boolean;
	}>;
}

export interface MyFeedbackListItem {
	id: string;
	templateName: string;
	submittedAt: string;
	isTied?: boolean;
	formName?: string;
	formTypeLabel?: string;
	instructorName?: string;
}

export interface FeedbackResponseListItem {
	id: string;
	taskId: string;
	candidateName: string;
	candidateStaffNumber: string;
	submittedAt: string;
	isTied?: boolean;
	formName?: string;
	formTypeLabel?: string;
	instructorName?: string;
}

export interface FeedbackResponseDetail {
	id: string;
	taskId: string;
	submittedAt: string;
	candidateName: string;
	candidateStaffNumber: string;
	template: FeedbackTemplateSnapshot | null;
	answers: FeedbackAnswerPayload[];
	isTied?: boolean;
	formName?: string;
	formTypeLabel?: string;
	instructorName?: string;
}

export interface FeedbackListParams {
	page?: number;
	size?: number;
	search?: string;
	formType?: string;
	role?: string;
	aocId?: string;
	aocIds?: string[];
	startDate?: string;
	endDate?: string;
}
